import { motion } from "framer-motion";
import { PIJLERS, PIJLERS_KERN } from "@/data/onderbouwing";

const ease = [0.22, 1, 0.36, 1];

function Pijler({ p, i }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-8%" }}
      transition={{ duration: 0.7, delay: (i % 3) * 0.1, ease }}
      data-testid={`pijler-${p.n}`}
      className="relative rounded-3xl bg-white border border-ll-ink/10 p-7 sm:p-8"
    >
      <div className="flex items-center gap-3">
        <span className="w-9 h-9 rounded-full flex items-center justify-center chapter-num text-sm" style={{ background: p.c, color: p.c === "#1F5132" ? "#FAF7F1" : "#1F5132" }}>
          {p.n}
        </span>
        <p className="font-heading text-2xl text-ll-ink">{p.t}</p>
      </div>
      <p className="mt-4 text-sm text-ll-navy/80 leading-relaxed">{p.d}</p>
    </motion.div>
  );
}

export default function ZesPijlers({ showNote = true }) {
  return (
    <div data-testid="zes-pijlers">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {PIJLERS.slice(0, 3).map((p, i) => <Pijler key={p.n} p={p} i={i} />)}
      </div>
      <motion.div
        initial={{ opacity: 0, scale: 0.97 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.9, ease }}
        className="relative my-4 rounded-[32px] bg-ll-navy text-ll-cream px-8 py-10 sm:px-14 sm:py-14 overflow-hidden"
        data-testid="pijlers-kern"
      >
        <div className="absolute inset-y-0 left-0 w-1.5 flex flex-col">
          {PIJLERS.map((p) => <span key={p.n} className="flex-1" style={{ background: p.c === "#1F5132" ? "#97B79D" : p.c }} />)}
        </div>
        <p className="text-[10px] uppercase tracking-[0.35em] text-ll-yellow">Zes pijlers · één samenhang</p>
        <p className="mt-5 font-heading font-light text-3xl sm:text-4xl lg:text-5xl leading-[1.08] max-w-4xl">
          {PIJLERS_KERN.split(". ")[0]}.{" "}
          <span className="italic text-ll-yellow">{PIJLERS_KERN.split(". ").slice(1).join(". ")}</span>
        </p>
      </motion.div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {PIJLERS.slice(3).map((p, i) => <Pijler key={p.n} p={p} i={i} />)}
      </div>
      {showNote && (
        <p className="mt-8 max-w-3xl text-sm text-ll-navy/70 leading-relaxed" data-testid="pijlers-nuance">
          Eerlijk is eerlijk: de afzonderlijke onderdelen komen ook bij andere aanbieders voor. Wat LevelLeven onderscheidend wil maken,
          zit in de samenhang, de uitvoering, de meetbaarheid en de overdracht. Dat willen we in pilots toetsen.
        </p>
      )}
    </div>
  );
}
